import React, { useEffect } from 'react';
import { HashRouter as Router, Switch, Route } from 'react-router-dom';
import { useLocation } from 'react-use';
import { createHashHistory } from 'history';
import ReactGA from 'react-ga4';
import { OutletsList } from './screens/outletsList';
import { OutletView } from './screens/outletView';
import { WithLocation } from './components/withLocation';
import './app.css';
import * as Sentry from "@sentry/react";

const trackingId = 'G-S42T7QSCL4';

Sentry.init({
  dsn: "https://a7e073b628fa41a7a1375c2678030bf5@itpiapi.lancaster.ac.uk:9000/24",
  integrations: [
    new Sentry.BrowserTracing(),
  ],
  tracesSampleRate: 1.0,
});

const Index = () => {
  const basename = window.location.pathname;
  const history = createHashHistory();
  const location = useLocation();

  ReactGA.initialize(trackingId);

  useEffect(() => {
    ReactGA.send({
      hitType: 'pageview',
      page: location.pathname
    });
  }, [location]);

  return (
    <WithLocation>
      <Router basename={basename} history={history}>
        <Switch>
          <Route path="/" exact component={OutletsList} />
          <Route path="/:id" exact component={OutletView} />
        </Switch>
      </Router>
    </WithLocation>
  );
};

export default Index;
